/*
 * @Author: ken yang
 * @Date: 2022-09-09 11:34:10
 * @LastEditTime: 2023-04-13 17:29:56
 * @LastEditors: ken yang
 * @Description: 钱包store
 * @FilePath: /uexch_pc/src/store/wallet.js
 */
import { AccountType } from '@/utils/constant.js'
import walletRoutes from '@/view/wallet/index.js'
import useUserStore from '@/store/user.js'
let menuRoutes = walletRoutes.routes[0]?.children[0]?.children
menuRoutes = menuRoutes.filter((obj) => obj.isMenu)
menuRoutes = menuRoutes.map((obj) => {
  return {
    path: obj.path,
    name: obj.name,
    title: obj.title,
  }
})
const useWalletStore = defineStore('walletStore', {
  state: () => {
    return {
      menuMaps: menuRoutes
    }
  },
  getters: {
  },
  actions: {
    /**
     * 资产信息获取工厂方法
     * @param {Number} accountType - 账户类型
     * @param {String} coinName - 币种名称
     * @returns {Object} 对应要求资产的信息对象
     *
     * @example
     * // 获取币币账户 (AccountType.SPOT) 的总体汇总数据 (包含总资产、总USDT折合、可用资产折合、额度限制等)
     * walletStore.assets(AccountType.SPOT)
     *
     * @example
     * // 获取币币账户 (AccountType.SPOT) 的 USDT 资产明细 (包含可用余额 amount、冻结余额 frozenAmount、排除限制数量 withoutOtcUserAmountLimit 等)
     * walletStore.assets(AccountType.SPOT, 'USDT')
     */
    assets (accountType = AccountType.SPOT, coinName = '') {
      const userStore = useUserStore()
      // 获取指定类型的账户数据，默认为空对象
      const accountData = userStore.accountInfo[accountType] || {}

      // 1. 如果没有传入具体币种，则返回账户总体汇总信息
      if (!coinName) {
        return {
          sumAmount: accountData.sumAmount || '0', // 资产总折合
          sumUsdtAmount: accountData.sumUsdtAmount || '0', // 资产总折合 (USDT)
          sumBtcAmount: accountData.sumBtcAmount || '0', // 资产总折合 (BTC)
          sumBtcUsableAmount: accountData.sumBtcUsableAmount || '0', // 可用资产折合 (排除冻结)
          otcUserBtcAmountLimit: accountData.otcUserBtcAmountLimit || '0', // 用户提币买币等限制数量 (统一折算单位)
          coinAccountList: accountData.coinAccountList || [], // 账户下的币种资产列表
          raw: accountData // 保留原始完整数据对象
        }
      }

      // 2. 如果传入了币种名称，查找该币种的详细数据
      const coinAccountList = accountData.coinAccountList || []
      const coinData = coinAccountList.find(
        c => c.coinName?.toUpperCase() === coinName.toUpperCase()
      ) || {}

      return {
        amount: coinData.amount || '0', // 可用余额
        frozenAmount: coinData.frozenAmount || '0', // 冻结余额
        withoutOtcUserAmountLimit: coinData.withoutOtcUserAmountLimit || '0', // 排除用户提币买币等限制数量
        convertUsdtAmount: coinData.convertUsdtAmount || '0', // 折合 USDT 的余额
        convertBtcAmount: coinData.convertBtcAmount || '0', // 折合 BTC 的余额
        convertCnyAmount: coinData.convertCnyAmount || '0', // 折合 CNY 的余额
        raw: coinData // 保留原始完整单币种数据对象
      }
    }
  },
  init () {
  }
})

export default useWalletStore
